import { render, staticRenderFns } from "./ScianCatalog.vue?vue&type=template&id=b43050f2&scoped=true&"
import script from "./ScianCatalog.vue?vue&type=script&lang=js&"
export * from "./ScianCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43050f2",
  null
  
)

export default component.exports